export default __webpack_public_path__ + "static/media/closedCardVertical.e409cdea.png";